import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
   providedIn: 'root',
})
export class AudioPlaylistPlayerService {
   private currentPlaylistIndexSubject: BehaviorSubject<number> = new BehaviorSubject<number>(-1);
   private isPausedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
   private isLoadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
   private showErrorSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
   private autoPlayAllSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

   constructor() {}

   get currentPlaylistIndex(): Observable<number> {
      return this.currentPlaylistIndexSubject.asObservable();
   }

   get isPaused(): Observable<boolean> {
      return this.isPausedSubject.asObservable();
   }

   get isLoading(): Observable<boolean> {
      return this.isLoadingSubject.asObservable();
   }

   get showError(): Observable<boolean> {
      return this.showErrorSubject.asObservable();
   }

   get autoPlayAll(): Observable<boolean> {
      return this.autoPlayAllSubject.asObservable();
   }

   setPlaylistIndex(index: number) {
      this.currentPlaylistIndexSubject.next(index);
   }

   setIsPaused(isPaused: boolean) {
      this.isPausedSubject.next(isPaused);
   }

   setIsLoading(isLoading: boolean) {
      this.isLoadingSubject.next(isLoading);
   }

   setShowError(showError: boolean) {
      this.showErrorSubject.next(showError);
   }

   setAutoPlayAll(autoPlayAll: boolean) {
      this.autoPlayAllSubject.next(autoPlayAll);
   }
}
